import { FC } from 'react';
import { useTranslation } from 'src/hooks/use-translation';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { SxProps, Theme } from '@mui/material/styles';

import LockIcon from 'icons/monochrome/lock.svg';

type Props = {
  size?: number;
  sx?: SxProps<Theme>;
};

export const TariffLockIcon: FC<Props> = ({ size = 16, sx }) => {
  const { t } = useTranslation('', { keyPrefix: 'tariff' });

  return (
    <Tooltip title={t('locked-tooltip')}>
      <Box
        component="span"
        sx={{ display: 'inline-flex', color: 'text.disabled', flexShrink: 0, ...sx }}
      >
        <LockIcon width={size} height={size} />
      </Box>
    </Tooltip>
  );
};
